import { FlowpageModel } from '@/components/layout/FlowpageModel';
import { SdkFlowPageModel } from '../models/flowPage';
import { SdkPopoverModel } from '../models/popover';
import { SdkSectionModel } from '../models/section';

type SdkToType = SdkFlowPageModel | SdkSectionModel | SdkPopoverModel;

export class SdkFlowPageChangeEvent {
  #from?: SdkFlowPageModel;
  #to: SdkToType;

  constructor(to: FlowpageModel, from?: FlowpageModel) {
    this.#from = from ? new SdkFlowPageModel(from) : undefined;
    this.#to = new SdkFlowPageModel(to);
  }

  get from() {
    return this.#from;
  }

  get to() {
    return this.#to;
  }
}
